import React from 'react'
import { ISpinnerProps } from 'native-base'
import VStack from './VStack'
import XSpinner from './XSpinner'
import XOverlay from './XOverlay'
import XText from './XText'

export interface IXSpinnerProps extends ISpinnerProps {
  isVisibleLoadingOverlay: boolean
  loadingText: string
}

const XOverlayLoading: React.FC<IXSpinnerProps> = ({ isVisibleLoadingOverlay, loadingText }) => {
  return (
    <XOverlay visible={isVisibleLoadingOverlay}>
      <VStack h='32' alignItems='center' justifyContent='center' space='2' w='full'>
        <XSpinner />
        <XText textAlign={'center'}>{loadingText}</XText>
      </VStack>
    </XOverlay>
  )
}

XOverlayLoading.displayName = 'XOverlayLoading'

export default XOverlayLoading
